import { Suggestion, ValidSuggestionTypes } from './types';

export type SuggestionsResponse = {
  error?: string;
  hits: {
    hits: {
      _source: {
        id: string;
        type: ValidSuggestionTypes;
        word: string;
        logo?: string;
        meta?: string;
        price?: number;
      };
    }[];
  };
};

export const getSuggestionsFromOldFormat = (
  data: SuggestionsResponse
): Suggestion[] => {
  const removeFirstHit =
    data.hits.hits.length > 1 &&
    data.hits.hits[0]._source.type === 'suggestion';

  let nextNavId = 1;
  return data.hits.hits
    .slice(removeFirstHit ? 1 : 0, removeFirstHit ? 11 : 10)
    .map(hit => ({
      text: hit._source.word,
      type: hit._source.type,
      id: hit._source.id,
      logo: hit._source.logo,
      // eslint-disable-next-line no-plusplus
      navId: nextNavId++,
      meta: hit._source.meta,
      price: hit._source.price,
    }));
};
